export default __webpack_public_path__ + "static/media/pWINGS.5ce7106f.png";